
import React from "react";
import { RssItem } from "./RssItem";
import { RssItemType, RssLayoutProps } from "./types";

export const RssMagazineLayout: React.FC<RssLayoutProps> = ({ items, content }) => {
  return (
    <div className="space-y-8 p-4">
      {items.map((item: RssItemType, index: number) => (
        <div key={index} className={`flex ${index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'} gap-6 border-b pb-8`}>
          {item.thumbnail && (
            <div className="w-1/3">
              <img src={item.thumbnail} alt="" className="rounded-lg w-full h-48 object-cover" />
            </div>
          )}
          <div className="flex-1">
            <RssItem item={item} content={content} />
          </div>
        </div>
      ))}
    </div>
  );
};

